"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FinancialEquipmentTypes = exports.CostField = exports.FleetType = void 0;
var FleetType;
(function (FleetType) {
    FleetType["Equipment"] = "Equipments";
    FleetType["RentalEquipment"] = "RentalEquipments";
})(FleetType = exports.FleetType || (exports.FleetType = {}));
;
;
;
var CostField;
(function (CostField) {
    CostField["DAILY"] = "daily";
    CostField["WEEKLY"] = "weekly";
    CostField["MONTHLY"] = "monthly";
})(CostField = exports.CostField || (exports.CostField = {}));
var FinancialEquipmentTypes;
(function (FinancialEquipmentTypes) {
    FinancialEquipmentTypes["RENTAL"] = "rental";
    FinancialEquipmentTypes["OWNED"] = "owned";
})(FinancialEquipmentTypes = exports.FinancialEquipmentTypes || (exports.FinancialEquipmentTypes = {}));
//# sourceMappingURL=procurementFleet.js.map